module.exports = __webpack_public_path__ + "7680a5a1.svg";